import * as Yup from 'yup';

export const inputSchema = Yup.object({
  items: Yup.array(Yup.object().shape({
    supply: Yup.object().required('Campo obrigatório').nullable(),
    quantity: Yup.number().required('Campo obrigatório'),
    unity: Yup.object().required('Campo obrigatório').nullable(),
    price: Yup.number().required('Campo obrigatório').nullable(),
    total: Yup.number(),
  })),
});
